import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

declare let $: any;

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private get accountApiUrl(): string {
    return environment.accountApiUrl;
  }

  constructor(public http: HttpClient) {
  }

  list(inParams: any = {}): any {
    const params = { ...inParams };

    if (params.$page) {
      params.$skip = (params.$page - 1) * (params.$limit);
    }

    if (params.$search) {
      params.$or = {
        fullname: { $like: `%${params.$search}%` },
        email: { $like: `%${params.$search}%` },
      };
      delete params.$search;
    }
    delete params.$page;

    const query = $.param(params);
    const url = `${this.accountApiUrl}/users?${query}`;
    return this.http.get(url);
  }

  save(model): any {
    if (!model.password) {
      delete model.password;
    }

    if (model.id) {
      const updateUrl = `${this.accountApiUrl}/users/${model.id}`;
      const body = this.toAccountUser(model);
      return this.http.patch(updateUrl, body);
    }

    delete model.id;
    const url = `${this.accountApiUrl}/users`;
    const body = this.toAccountUser(model);
    return this.http.post(url, body);
  }

  detail(id): any {
    const url = `${this.accountApiUrl}/users/${id}`;
    const params: any = {};
    return this.http.get(url, { params });
  }

  delete(model): any {
    const url = `${this.accountApiUrl}/users/${model.id}`;
    return this.http.delete(url);
  }

  changePassword(id: number, currentPassword: string, newPassword: string): any {
    const url = `${this.accountApiUrl}/users/${id}`;
    return this.http.patch(url, {
      password: newPassword,
      rawPassword: currentPassword
    });
  }

  private toAccountUser(model: any): any {
    const body = { ...model };
    if (body.fullname !== undefined) {
      body.fullName = body.fullname;
      delete body.fullname;
    }
    if (body.thumbnail !== undefined) {
      body.profileImage = body.thumbnail;
      delete body.thumbnail;
    }
    if (body.phone !== undefined) {
      body.phoneNumber = body.phone;
      delete body.phone;
    }
    const allowed = new Set([
      'id',
      'username',
      'email',
      'password',
      'rawPassword',
      'fullName',
      'phoneNumber',
      'role',
      'status',
      'backupFileName',
      'backupFileNameDate',
      'otpForgot',
      'otpVerify',
      'verifyStatus',
      'is_notification',
      'is_dark_mode',
      'profileImage',
      'groupId'
    ]);
    for (const key of Object.keys(body)) {
      if (!allowed.has(key)) {
        delete body[key];
      }
    }
    return body;
  }
}
